import React, { Component } from 'react'
import styled from 'styled-components'
import { provideState, injectState } from 'freactal'
import app from '../../../../feathers'
import {
  deserializeContentSection,
  serializeContentSection,
  sectionIndexToPath,
} from '../../../../lib'

import { Link, Prompt } from 'react-router-dom'
import { Spinner, IconButton } from 'react-mdl'
import Button from '../../../../components/Button'
import Editor from '../../../../components/Editor'
import QuestionPanel from './QuestionPanel'

const ContentContainer = styled.div`
  display: flex;
  flex-direction: row;
  min-height: 10em;
`
const EditorContainer = styled.div`
  position: relative;
  width: 20.5cm;
  flex-grow: 0;
  flex-shrink: 0;
  padding: 0.5em;
`
const QuestionsContainer = styled.div`
  flex-grow: 3;
  flex-shrink: 3;
  padding: 0.5em;
`
const ActionContainer = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 0.5em;
`
const QuestionsHeader = styled.div`
  border: 1px solid black;
  padding: 0.25em;
  font-weight: bold;
`
const Questions = styled.div`
  border: 1px solid black;
  padding: 0.25em;
`

const withState = provideState({
  initialState: () => ({
    updateSectionContentError: null,
  }),
  effects: {
    updateSectionContent: async (effects, { _id, sectionIndex, content }) => {
      try {
        const sectionPath = sectionIndexToPath(sectionIndex)
        await app.service('units').patch(_id, {
          [`sections.${sectionPath}.content`]: content,
        })
      } catch (updateSectionContentError) {
        return () => ({ updateSectionContentError })
      }
    },
  },
})

class SectionEditor extends Component {
  state = {
    savePending: false,
    saving: false,
    editorState: deserializeContentSection(this.props.initalContent),
  }
  onChange = editorState => {
    this.setState({ editorState, savePending: true })
  }
  onSave = async () => {
    const {
      sectionIndex,
      state: { unit: { _id } },
      effects: { updateSectionContent },
    } = this.props
    const { editorState } = this.state
    const content = serializeContentSection(editorState)

    this.setState({ saving: true })
    await updateSectionContent({
      _id,
      sectionIndex: sectionIndex.join('.'),
      content,
    })
    this.setState({ saving: false, savePending: false })
  }
  render() {
    const { editorState, saving, savePending } = this.state
    const {
      displayQuestions,
      questions,
      sectionIndex,
      sectionName,
      state: { unit: { _id: unitId, images = [] } },
    } = this.props
    return (
      <ContentContainer>
        <EditorContainer>
          <Editor
            state={editorState}
            onChange={this.onChange}
            unitImages={images}
          />
          <Link
            to={`/units/${unitId}/learner-guide/${sectionIndex
              .slice(0, 2)
              .join('.')}/${sectionIndex.join('.')}/mapping`}
            style={{
              position: 'absolute',
              top: '0.75em',
              right: '1em',
            }}>
            <IconButton name="map" accent />
          </Link>
          <ActionContainer>
            {saving ? (
              <Spinner />
            ) : (
              <Button
                raised
                primary
                disabled={!savePending}
                onClick={this.onSave}>
                Save Section Content
              </Button>
            )}
          </ActionContainer>
        </EditorContainer>
        {displayQuestions && (
          <QuestionsContainer>
            <QuestionsHeader>Questions</QuestionsHeader>
            <Questions>
              {questions
                .map((question, questionIndex) => ({
                  ...question,
                  questionIndex,
                }))
                .sort(
                  // Sort by type and index
                  (a, b) =>
                    a.type === 'review' && b.type === 'final'
                      ? -1
                      : a.type === 'final' && b.type === 'review'
                        ? 1
                        : a.questionIndex < b.questionIndex
                          ? -1
                          : a.questionIndex > b.questionIndex ? 1 : 0,
                )
                .map((question, i) => (
                  <QuestionPanel
                    key={i}
                    sectionIndex={sectionIndex}
                    {...question}
                  />
                ))}
            </Questions>
            <Link
              to={{
                pathname: `./${sectionIndex.join('.')}/question/`,
                state: {
                  newQuestion: true,
                },
              }}>
              <Button raised primary>
                Add Question
              </Button>
            </Link>
          </QuestionsContainer>
        )}
        <Prompt
          when={savePending}
          message={`You have unsaved content in "${sectionIndex
            .map(i => i + 1)
            .join('.')} ${sectionName}"`}
        />
      </ContentContainer>
    )
  }
}

export default withState(injectState(SectionEditor))



// WEBPACK FOOTER //
// ./src/Units/ManageUnit/LearnerGuide/SectionContent/SectionEditor.js